module.exports = __webpack_public_path__ + "operace-usnich-boltcu_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-usnich-boltcu_3_after.jpg
// module id = 1215
// module chunks = 0